import { Route, Routes } from "react-router-dom";
import Dashboard from "../components/Dashboard/Dashboard";
import Login from "../components/Login/Login";
import CustomersList from "../components/Users/List/CustomersList";
import DeletedCustomersList from "../components/Users/List/DeletedCustomersList";
import ProvidersList from "../components/Users/List/ProvidersList";
import DeletedProvidersList from "../components/Users/List/DeletedProvidersList";

import RequestsList from "../components/Requests/List/RequestsList";
import BookingsList from "../components/Bookings/List/BookingsList";
import ProtectedRoute from "./ProtectedRoute"
import ValidationRoute from "./ValidationRoute"
import ProviderPaymentsList from "../components/ProviderPayments/List/ProviderPaymentsList";
import WeeklyChargesList from "../components/WeeklyCharges/List/WeeklyChargesList";

const routing = (
    <Routes>
        <Route path="/" element={<ProtectedRoute element={<Login />} />} />
        <Route path="/login" element={<ProtectedRoute element={<Login />}  />} />̆
        <Route path="/dashboard" element={<ValidationRoute element={<Dashboard />}  />} />
        <Route path="/customers" element={<ValidationRoute element={<CustomersList />}  />} />
        <Route path="/deleted_customers" element={<ValidationRoute element={<DeletedCustomersList />}  />} />
        <Route path="/providers" element={<ValidationRoute element={<ProvidersList />}  />} />
        <Route path="/deleted_providers" element={<ValidationRoute element={<DeletedProvidersList />}  />} />
        <Route path="/requests" element={<ValidationRoute element={<RequestsList />}  />} />
        <Route path="/bookings" element={<ValidationRoute element={<BookingsList />}  />} />
        <Route path="/provider_payments" element={<ValidationRoute element={<ProviderPaymentsList />}  />} />
        <Route path="/weekly_charges" element={<ValidationRoute element={<WeeklyChargesList />}  />} />
    </Routes>
  
);

export default routing;